import { Box, InputLabel, Typography } from '@mui/material';
import React from 'react'
import { TbExternalLink } from 'react-icons/tb';

const Menu = ({data}) => {
  return (
     <>
                      <Typography
                        sx={{
                          fontWeight: 300,
                          fontSize: {
                            lg: '14px',
                            md: '14px',
                            sm: '12px',
                            xs: '12px',
                          },
                        }}
                      >
                        Explore the menu offerings at {data?.RestaurantName} and
                        discover the most popular dishes that people are
                        craving! From appetizers to desserts, take a look at
                        what's in store for you when you reserve a table at{' '}
                        {data?.RestaurantName} . You can also check out the
                        prices to get an idea of what to expect, in addition to
                        the flavors. Browse through the menu highlights from{' '}
                        {data?.RestaurantName} and let your taste buds indulge
                        in the delectable offerings. We're already getting
                        hungry just thinking about it...
                      </Typography>

                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          columnGap: 1,
                          mt: 3,
                        }}
                      >
                        <TbExternalLink style={{ color: '#BC172F' }} />
                        <a href={data?.MenuLink} target="_blank">
                          <Typography color="primary">
                            Open restaurant's full menu
                          </Typography>
                        </a>
                      </Box>
                      {data?.Menu?.length > 0 && (
                        <>
                          <Box
                            sx={{
                              mt: 5,
                              border: '1px solid #d7d7d7',
                              borderRadius: '10px',
                              pb: 4,
                            }}
                          >
                            <Box
                              sx={{
                                bgcolor: '#BC172F',
                                p: 3,
                                fontWeight: 500,
                                fontSize: '18px',
                                color: '#fff',
                                borderRadius: '10px 10px 0px 0px',
                                fontSize: {
                                  lg: '14px',
                                  md: '14px',
                                  sm: '12px',
                                  xs: '12px',
                                },
                              }}
                            >
                              Menu Highlights
                            </Box>
                            <Box sx={{ mt: 2, px: 3 }}>
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  columnGap: 2,
                                }}
                              >
                                {/* <Avatar src={logo} variant="rounded" sx={{border:'1px solid #BC172F', objectFit:'cover'}} /> */}
                                <Typography
                                  color="primary"
                                  sx={{
                                    fontWeight: 500,
                                    fontSize: {
                                      lg: '16px',
                                      md: '16px',
                                      sm: '14px',
                                      xs: '14px',
                                    },
                                  }}
                                >
                                  Main Courses
                                </Typography>
                              </Box>
                              {data?.Menu?.map((menu, index) => {
                                const isMainCourse =
                                  menu?.Category === 'Main Courses';
                                return (
                                  <Box
                                    sx={{
                                      mt: 2,
                                      display: 'flex',
                                      alignItems: 'center',
                                      columnGap: 2,
                                      justifyContent: 'space-between',
                                      ...(!isMainCourse && {
                                        display: 'none',
                                      }),
                                    }}
                                  >
                                    <Box sx={{ width: '70%' }}>
                                      <InputLabel
                                        sx={{
                                          fontWeight: 500,
                                          fontSize: {
                                            lg: '14px',
                                            md: '14px',
                                            sm: '12px',
                                            xs: '12px',
                                          },
                                        }}
                                      >
                                        {menu?.Item}
                                      </InputLabel>
                                      <InputLabel
                                        sx={{
                                          fontSize: {
                                            lg: '12px',
                                            md: '12px',
                                            sm: '10px',
                                            xs: '10px',
                                          },
                                        }}
                                      >
                                        {menu?.Description}
                                      </InputLabel>
                                    </Box>
                                    <Typography
                                      sx={{
                                        fontWeight: 500,
                                        fontSize: {
                                          lg: '14px',
                                          md: '14px',
                                          sm: '12px',
                                          xs: '12px',
                                        },
                                      }}
                                    >
                                      ₦{menu?.Price?.toLocaleString()}
                                    </Typography>
                                  </Box>
                                );
                              })}
                            </Box>
                            <Box sx={{ mt: 3, px: 3 }}>
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  columnGap: 2,
                                }}
                              >
                                {/* <Avatar src={logo} variant="rounded" sx={{border:'1px solid #BC172F', objectFit:'cover'}} /> */}
                                <Typography
                                  color="primary"
                                  sx={{
                                    fontWeight: 500,
                                    fontSize: {
                                      lg: '16px',
                                      md: '16px',
                                      sm: '14px',
                                      xs: '14px',
                                    },
                                  }}
                                >
                                  Starters/Appetizers
                                </Typography>
                              </Box>
                              {data?.Menu?.map((menu, index) => {
                                const isMainCourse =
                                  menu?.Category === 'Starters/Appetizers';
                                return (
                                  <Box
                                    sx={{
                                      mt: 2,
                                      display: 'flex',
                                      alignItems: 'center',
                                      columnGap: 2,
                                      justifyContent: 'space-between',
                                      ...(!isMainCourse && {
                                        display: 'none',
                                      }),
                                    }}
                                  >
                                    <Box sx={{ width: '70%' }}>
                                      <InputLabel
                                        sx={{
                                          fontWeight: 500,
                                          fontSize: {
                                            lg: '14px',
                                            md: '14px',
                                            sm: '12px',
                                            xs: '12px',
                                          },
                                        }}
                                      >
                                        {menu?.Item}
                                      </InputLabel>
                                      <InputLabel
                                        sx={{
                                          fontSize: {
                                            lg: '12px',
                                            md: '12px',
                                            sm: '10px',
                                            xs: '10px',
                                          },
                                        }}
                                      >
                                        {menu?.Description}
                                      </InputLabel>
                                    </Box>
                                    <Typography
                                      sx={{
                                        fontWeight: 500,
                                        fontSize: {
                                          lg: '14px',
                                          md: '14px',
                                          sm: '12px',
                                          xs: '12px',
                                        },
                                      }}
                                    >
                                      ₦{menu?.Price?.toLocaleString()}
                                    </Typography>
                                  </Box>
                                );
                              })}
                            </Box>
                          </Box>
                        </>
                      )}
                    </>
  )
}

export default Menu
